import Airtable from 'airtable';

// api keys are confidential
const base = new Airtable({ apiKey: 'patuWmr3LRYCSVbUS.9cdc120dc630224fbfd82d162ddf2df213b4c3f146b3ee401181e0d53b68f8d2' }).base(
  'appXinwCNWlwM0V0K'
);

export default base;
